module.exports = __webpack_public_path__ + "img/canbadge-round-44mm-2.0-credit.bc6ca195.png";